<div style="display: flex; flex-wrap: wrap;flex:1;justify-content: space-between">
  <div style="max-width:48%;box-sizing: border-box;display: inline-block;width:100%;" *ngFor="let cam of device?.cameras">
    <app-livestream [LIVESTREAM_URL]="enviroment.LIVESTREAM_URL" [dn]="device?.dn" [cam]="cam" #playerComponent></app-livestream>
  </div>
</div>
